import React from 'react'
import { FormatDateOptions, useIntl } from 'react-intl'

import styles from './styles.module.css'
import { Text } from 'src/comps/Atom/Text'

interface IManagementResponseProps {
  date: string
  text: string
}

const formatDateOptions: FormatDateOptions = {
  day: '2-digit',
  month: '2-digit',
  year: '2-digit',
}

export function ManagementResponse(props: Readonly<IManagementResponseProps>) {
  const { date, text } = props
  const intl = useIntl()

  const dateStr = intl.formatDate(new Date(date), formatDateOptions)
  return (
    <div className={styles.responseContainer}>
      <div className={styles.header}>
        <Text as="span" variant="captionL" weight="weight3" className={styles.title}>
          {intl.formatMessage({ id: 'global.reviews-response' })}
        </Text>
        ·
        <Text as="span" variant="captionL" weight="weight1" className={styles.date}>
          {dateStr}
        </Text>
      </div>
      <Text as="p" variant="captionL">
        {text}
      </Text>
    </div>
  )
}
